import { ServerError } from '@apollo/client/errors';

// `Middleware::WebClientVersionChecker` answers 422 with this body when the tab
// runs a bundle older than the minimum the API accepts.
const STALE_VERSION_MESSAGE = 'old web app version please refresh the window';

export const isStaleWebAppVersionError = (error: unknown) => {
  if (!ServerError.is(error) || error.statusCode !== 422) {
    return false;
  }

  try {
    const body = JSON.parse(error.bodyText) as { error?: string };
    return body.error === STALE_VERSION_MESSAGE;
  } catch {
    return false;
  }
};
